import axios from "axios";
import { ClientInfo } from "./types";

const BASE_URL = window.RUNTIME_CONFIG?.BACKEND_URL;;

export const fetchClientInfo = () =>
  axios.get<ClientInfo>(`${BASE_URL}/api/client`).then((res) => res.data);

export const castVote = (voteData: number[]) =>
  axios.post<ClientInfo>(`${BASE_URL}/api/votes`, { vote_data: voteData }).then((res) => res.data);